import styled from 'styled-components'

export const Container = styled.div`
  .link {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.brandPrimary};
    font-size: ${({ theme }) => theme.fontSize.xxs};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    cursor: pointer;

    svg {
      font-size: ${({ theme }) => theme.fontSize.xs};
      margin-right: ${({ theme }) => theme.space.xxs};
    }

    .underline {
      text-decoration: underline;
    }
  }
`
